import api from '@/api/api'


export default {
  MONITORAR ({ commit }, {usuario, clientinfo, cidade, descricao, procedimento}) {
      return new Promise(async (resolve, reject) =>{
          try {
          const info = await api.monitorar(usuario, clientinfo, cidade, descricao, procedimento)
          commit("MONITORAR", info )
          resolve(info)
          } catch (error) {
          reject(error)
          }
      })
  },
    
}